<template>
  <div class="c-drop-filter">
    <div class="c-drop-box" :class="{ 'c-box-shadow': value }" ref="drapMask">
      <div class="c-control" @click="$emit('input', !value)">
        <div class="c-btn-filter">
          <Icon v-if="value" type="ios-funnel" color="#2d8cf0" :size="14" />
          <Icon v-else type="ios-funnel-outline" color="#2d8cf0" :size="14" />
          <el-button type="text">{{ title }}</el-button>
          <Icon v-if="value" type="ios-arrow-up" :size="16" color="#808695" />
          <Icon v-else type="ios-arrow-down" :size="16" color="#808695" />
        </div>
      </div>
      <div class="c-slot" :style="slotStyle">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'dropFilter',
  props: {
    value: {
      type: Boolean
    }
  },
  computed: {
    title() {
      return this.value ? '收缩' : '展开'
    },
    slotStyle() {
      return this.value ? '' : { height: '36px' }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.document.onclick = () => {
        this.$emit('input', false)
      }
      if (this.$refs.drapMask) {
        this.$refs.drapMask.onclick = (e) => {
          e.stopPropagation()
          return false
        }
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.c-drop-filter {
  height: 36px;

  .c-drop-box {
    display: flex;
    background-color: #fff;
    position: relative;
    overflow: hidden;
    z-index: 98;

    .c-control {
      flex: 0 0 70px;
      cursor: pointer;
      display: flex;

      .c-btn-filter {
        display: inline-block;
        border-radius: 4px;
        line-height: 30px;
        color: #808695;
      }

      span {
        margin: 0 8px;
        display: inline-block;
        vertical-align: center;
        color: #2d8cf0;
      }
    }

    .c-slot {
      flex: auto;
    }

    &.c-box-shadow {
      border-bottom: 1px solid #e4e9ed;

      .c-control {
        background-color: #fcfcfc;
      }
    }
  }
}
</style>
